<template>
  <button
    class="subscription-button text-button"
    data-test-id="subscription-button"
    @click="handleSubscriptionClick"
  >
    <icon-component
      name="bell"
      title="bell icon"
      class="subscription-button__icon"
      :class="{ 'subscription-button__icon--filled': isSubscribed }"
    />
    {{ buttonText }}
  </button>
</template>

<script>
import { mapGetters } from 'vuex';
import { MANAGE_SUBSCRIPTION } from '@/graphql/mutations/notification-mutations';
import { GET_SINGLE_THREAD_QUERY } from '@/graphql/queries/forum-queries';

export default {
  name: 'SubscriptionButton',
  props: {
    subscribable: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubscribed: false,
    };
  },
  computed: {
    ...mapGetters([
      'userIsLoggedIn',
      'currentUser',
    ]),
    buttonText() {
      return this.isSubscribed ? 'Unsubscribe' : 'Subscribe to updates';
    },
    notificationDescription() {
      if (this.isSubscribed) {
        return 'You have been subscribed to updates';
      }
      return 'You have been unsubscribed from updates';
    },
    assocType() {
      return this.subscribable.type ? 'POST' : 'THREAD';
    },
  },
  mounted() {
    this.isSubscribed = this.subscribable.is_subscribed;
  },
  methods: {
    handleSubscriptionClick(event) {
      if (!this.userIsLoggedIn) {
        this.$store.dispatch('openRegisterDialog');
        return;
      }
      this.$snowplow.trackButtonEvent({
        data: {
          type: `${this.isSubscribed ? 'unsubscribe from notifications' : 'subscribe to notifications'}`,
          text: event.target.textContent.trim(),
          classes: event.target.classList,
          id: event.target.id,
        },
      });
      this.updateSubscription();
    },
    updateSubscription() {
      const id = this.$route.params.id || null;
      const slug = this.$route.params.slug || null;
      const subscribing = !this.isSubscribed;

      this.$apollo.mutate({
        mutation: MANAGE_SUBSCRIPTION,
        variables: {
          assocId: this.subscribable.id,
          assocType: this.assocType,
          subscribing,
        },
        update(cache) {
          // read from cache
          const data = cache.readQuery({
            query: GET_SINGLE_THREAD_QUERY,
            variables: {
              id,
              slug,
            },
          });
          // update cache data
          data.thread.is_subscribed = subscribing;

          // write to cache
          cache.writeQuery({
            query: GET_SINGLE_THREAD_QUERY,
            data,
          });
        },
      }).then(() => {
        this.isSubscribed = !this.isSubscribed;
        this.$store.dispatch('addToastNotification', {
          toastType: 'success',
          description: this.notificationDescription,
          type: 'Subscribe to UGC',
        });
      }).catch(() => {
        this.$store.dispatch('addToastNotification', {
          toastType: 'error',
          description: 'Something went wrong. Please try again.',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_subscription-button';
</style>
